<template>
  <div class="payment-screen" :class="{ 'payment-screen--eudora': brand === 'eudora' }">
    <div class="payment-screen__detail-grid">
    <h5 class="payment-screen__title">Forma de pagamento</h5>

    <p class="payment-screen__section-label payment-screen__section-label--desktop-first">Escolha como deseja pagar</p>

    <div class="payment-card" v-if="prepareToSetAgreement">
      <div class="payment-card__brand">
        <img
          :src="brand === 'eudora' ? '/img/eudora-icone-card.png' : '/img/boticario-icone-card.png'"
          alt=""
          class="payment-card__brand-icon"
        />
        <strong class="payment-card__brand-name">{{ brandDisplayName }}</strong>
      </div>

      <div class="payment-card__row">
        <span class="payment-card__label">Valor do acordo:</span>
        <strong class="payment-card__value">{{ agreementTotalValue }}</strong>
      </div>

      <template v-if="isAVista">
        <div class="payment-card__row">
          <span class="payment-card__label">Plano:</span>
          <strong class="payment-card__value">À vista</strong>
        </div>
        <div class="payment-card__row">
          <span class="payment-card__label">Valor do pagamento:</span>
          <strong class="payment-card__value">{{ paymentValue }}</strong>
        </div>
      </template>

      <template v-else>
        <div class="payment-card__row">
          <span class="payment-card__label">Plano:</span>
          <strong class="payment-card__value">Parcelado</strong>
        </div>
        <div v-if="hasEntradaParcela" class="payment-card__row">
          <span class="payment-card__label">Entrada:</span>
          <strong class="payment-card__value">{{ entradaFormatted }}</strong>
        </div>
        <div class="payment-card__row">
          <span class="payment-card__label">Parcelas:</span>
          <strong class="payment-card__value">{{ parcelasFormatted }}</strong>
        </div>
      </template>

      <div class="payment-card__row">
        <span class="payment-card__label">Vencimento do acordo:</span>
        <strong class="payment-card__value">{{ agreementDueDateFormatted }}</strong>
      </div>

      <hr class="payment-card__divider" />

      <div class="payment-card__titles-row">
        <span class="payment-card__label">Título(s) negociados:</span>
        <span class="payment-card__titles-value">
          {{ isTitlesExpanded ? titulos : truncated(titulos, 20) }}
        </span>
        <button
          v-if="titulos && titulos.length > 20"
          class="payment-card__btn-expand"
          @click="isTitlesExpanded = !isTitlesExpanded"
        >
          <i :class="isTitlesExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </button>
      </div>
    </div>

    <p class="payment-screen__section-label payment-screen__section-label--mobile-only">Escolha como deseja pagar</p>

    <div class="payment-options">
      <div
        v-if="isAVista && isPixPaymentEnabled"
        class="payment-option"
        :class="{ 'payment-option--selected': selectedPaymentMethod === 'P' }"
        @click="selectPayment('P')"
      >
        <div class="payment-option__start">
          <span class="payment-option__icon">
            <img src="/img/pix-icon.svg" alt="" class="payment-option__pix-img" width="15" height="15" />
          </span>
          <span class="payment-option__label">PIX</span>
        </div>
        <span v-if="selectedPaymentMethod === 'P'" class="payment-option__check" aria-hidden="true">
          <svg class="payment-option__check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" :fill="brandAccent"/>
            <path d="M7.5 12l2.5 2.5L16.5 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>

      <div v-if="isAVista && isAcceptCardEnabled" class="payment-option-stack">
        <div
          class="payment-option"
          :class="{ 'payment-option--selected-card': selectedPaymentMethod === 'L' }"
          @click="selectPayment('L')"
        >
          <div class="payment-option__start">
            <span class="payment-option__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="5" width="20" height="14" rx="2" stroke="#333438" stroke-width="1.5"/>
                <path d="M2 10h20" stroke="#333438" stroke-width="1.5"/>
                <rect x="5" y="14" width="4" height="2" rx="0.5" fill="#333438"/>
              </svg>
            </span>
            <span class="payment-option__label">Cartão de crédito</span>
          </div>
          <span v-if="selectedPaymentMethod === 'L'" class="payment-option__check" aria-hidden="true">
            <svg class="payment-option__check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11" :fill="brandAccent"/>
              <path d="M7.5 12l2.5 2.5L16.5 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
        <div v-if="selectedPaymentMethod === 'L'" class="payment-option-card-info">
          <div class="payment-option-card-info__row">
            <div class="payment-option-card-info__gutter" aria-hidden="true"></div>
            <p class="payment-option-card-info__text">
              Para pagamentos com cartão de crédito, vamos te direcionar para finalizar em um ambiente seguro.
            </p>
          </div>
          <div class="payment-option-card-info__row">
            <div class="payment-option-card-info__gutter">
              <span class="payment-option-card-info__icon-wrap" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" :fill="brandAccent"/>
                  <path d="M12 8v5M12 16h.01" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </span>
            </div>
            <p class="payment-option-card-info__text">
              Atenção: Parcelamento em até 10x, e você tem a possibilidade de utilizar até 9 cartões de titulares diferentes.
            </p>
          </div>
          <div class="payment-option-card-info__row">
            <div class="payment-option-card-info__gutter" aria-hidden="true"></div>
            <p class="payment-option-card-info__text">
              (Parcelamento sujeito à taxa de juros da operadora).
            </p>
          </div>
        </div>
      </div>

      <div
        class="payment-option"
        :class="{ 'payment-option--selected': selectedPaymentMethod === 'B' }"
        @click="selectPayment('B')"
      >
        <div class="payment-option__start">
          <span class="payment-option__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="4" width="2" height="16" fill="#333438"/>
              <rect x="6" y="4" width="1" height="16" fill="#333438"/>
              <rect x="9" y="4" width="2" height="16" fill="#333438"/>
              <rect x="13" y="4" width="1" height="16" fill="#333438"/>
              <rect x="16" y="4" width="2" height="16" fill="#333438"/>
              <rect x="20" y="4" width="2" height="16" fill="#333438"/>
            </svg>
          </span>
          <span class="payment-option__label">Boleto</span>
        </div>
        <span v-if="selectedPaymentMethod === 'B'" class="payment-option__check" aria-hidden="true">
          <svg class="payment-option__check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" :fill="brandAccent"/>
            <path d="M7.5 12l2.5 2.5L16.5 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div> 
    </div>
    </div>

    <div class="payment-screen__footer-actions">
    <ProgressLoading :loading="loadingSetAgreement" />

    <button
      class="btn-confirm-agreement"
      :disabled="!selectedPaymentMethod || loadingSetAgreement"
      @click="openReviewModal"
    >
      CONFIRMAR ACORDO
    </button>

    <button type="button" class="btn-back-offer" @click="voltar">
      Voltar para detalhes da oferta
    </button>
    </div>

    <div
      v-if="showReviewModal"
      class="payment-review-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="payment-review-title"
      @click.self="closeReviewModal"
    >
      <div class="payment-review-dialog">
        <div class="payment-review-header">
          <h2 id="payment-review-title" class="payment-review-title">Confirmar acordo</h2>
          <button type="button" class="payment-review-close" aria-label="Fechar" @click="closeReviewModal(true)">
            &times;
          </button>
        </div>
        <p class="payment-review-subtitle">Informações do seu acordo</p>

        <div class="payment-review-card" v-if="prepareToSetAgreement">
          <div class="payment-review-card__brand">
            <img
              :src="brand === 'eudora' ? '/img/eudora-icone-card.png' : '/img/boticario-icone-card.png'"
              alt=""
              class="payment-review-card__brand-icon"
            />
            <strong class="payment-review-card__brand-name">{{ brandDisplayName }}</strong>
          </div>

          <div class="payment-review-card__row">
            <span class="payment-review-card__label">Valor do acordo:</span>
            <strong class="payment-review-card__value">{{ agreementTotalValue }}</strong>
          </div>

          <template v-if="isAVista">
            <div class="payment-review-card__row">
              <span class="payment-review-card__label">Plano:</span>
              <strong class="payment-review-card__value">À vista</strong>
            </div>
            <div class="payment-review-card__row">
              <span class="payment-review-card__label">Valor do pagamento:</span>
              <strong class="payment-review-card__value">{{ paymentValue }}</strong>
            </div>
          </template>
          <template v-else>
            <div class="payment-review-card__row">
              <span class="payment-review-card__label">Plano:</span>
              <strong class="payment-review-card__value">Parcelado</strong>
            </div>
            <div v-if="hasEntradaParcela" class="payment-review-card__row">
              <span class="payment-review-card__label">Entrada:</span>
              <strong class="payment-review-card__value">{{ entradaFormatted }}</strong>
            </div>
            <div class="payment-review-card__row">
              <span class="payment-review-card__label">Parcelas:</span>
              <strong class="payment-review-card__value">{{ parcelasFormatted }}</strong>
            </div>
          </template>

          <div class="payment-review-card__row">
            <span class="payment-review-card__label">Vencimento:</span>
            <strong class="payment-review-card__value">{{ agreementDueDateFormatted }}</strong>
          </div>
          <div class="payment-review-card__row">
            <span class="payment-review-card__label">Forma de pagamento:</span>
            <strong class="payment-review-card__value">{{ paymentMethodLabel }}</strong>
          </div>
        </div>

        <button
          type="button"
          class="payment-review-btn-confirm"
          :disabled="loadingSetAgreement"
          @click="onModalConfirmAgreement"
        >
          {{ loadingSetAgreement ? 'CARREGANDO...' : 'CONFIRMAR ACORDO' }}
        </button>
        <button type="button" class="payment-review-btn-cancel" @click="closeReviewModal(true)">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import ProgressLoading from '@/modules/auth/components/ProgressLoading';
import { brandAccentColor } from '@/utils/brandColors';
import { isPixPaymentEnabled as readPixPaymentFlag } from '@/pages/home/utils/paymentFlags';

export default {
  name: 'PaymentScreen',
  components: { ProgressLoading },
  props: {
    brand: { type: String, default: 'boticario' },
  },
  data: () => ({
    isTitlesExpanded: false,
    showReviewModal: false,
  }),
  computed: {
    brandDisplayName() {
      return this.brand === 'eudora' ? 'Eudora' : 'Boticário';
    },
    brandAccent() {
      return brandAccentColor(this.brand);
    },
    isPixPaymentEnabled() {
      return readPixPaymentFlag();
    },
    paymentMethodLabel() {
      const m = this.selectedPaymentMethod;
      if (m === 'P') return 'PIX';
      if (m === 'L') return 'Cartão de crédito';
      if (m === 'B') return 'Boleto';
      return '—';
    },
    ...mapState('negotiation', [
      'prepareToSetAgreement', 'selectedPaymentMethod', 'loadingSetAgreement',
    ]),
    isAVista() {
      return parseInt(this.prepareToSetAgreement?.installmentNumber) <= 1;
    },
    hasEntradaParcela() {
      const p = this.prepareToSetAgreement;
      return !!p && parseFloat(p.entryValue || 0) > 0;
    },
    entradaFormatted() {
      const p = this.prepareToSetAgreement;
      if (!p) return '';
      return `R$ ${p.minimumEntryValueFormatted}`;
    },
    parcelasFormatted() {
      const p = this.prepareToSetAgreement;
      if (!p) return '';
      return `${p.installmentNumber}x de R$ ${p.installmentValueFormatted}`;
    },
    paymentValue() {
      if (!this.prepareToSetAgreement) return '';
      return `R$ ${this.prepareToSetAgreement.installmentValueFormatted}`;
    },
    agreementTotalValue() {
      const p = this.prepareToSetAgreement;
      if (!p) return '';

      const installmentNumber = Number(p.installmentNumber);
      const installmentValueNumber = Number(p.installmentValue);
      if (!Number.isNaN(installmentNumber) && installmentNumber > 1 && !Number.isNaN(installmentValueNumber)) {
        const total = installmentValueNumber * installmentNumber;
        return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }
      if (!Number.isNaN(installmentValueNumber)) {
        return installmentValueNumber.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }

      const formatted = String(p.installmentValueFormatted || '').trim();
      if (!formatted) return '';
      return `R$ ${formatted.replace(/^R\$\s?/i, '')}`;
    },
    agreementDueDateFormatted() {
      const raw = this.prepareToSetAgreement?.dueDate;
      if (raw == null || raw === '') return '';
      const m = moment(raw, ['YYYY-MM-DD', 'DD/MM/YYYY', 'D/M/YYYY'], true);
      if (m.isValid()) return m.format('DD/MM/YYYY');
      const loose = moment(raw);
      return loose.isValid() ? loose.format('DD/MM/YYYY') : String(raw);
    },
    titulos() {
      return this.prepareToSetAgreement?.installments || '';
    },
    isAcceptCardEnabled() {
      return this.$store.getters['negotiation/isAcceptCardEnabled'](this.prepareToSetAgreement);
    },
  },
  methods: {
    ...mapActions('negotiation', [
      'ActionNegotiationSelectPaymentMethod',
      'ActionNegotiationSetAgreementBoticario',
      'ActionNegotiationSetAgreementEudora',
    ]),

    selectPayment(method) {
      this.ActionNegotiationSelectPaymentMethod(method);
    },

    voltar() {
      this.showReviewModal = false;
      const view = this.brand === 'eudora' ? 'negotiationEudora' : 'negotiationBoticario';
      this.$store.commit('negotiation/SET_VIEW', view);
    },

    openReviewModal() {
      if (!this.selectedPaymentMethod) return;
      this.showReviewModal = true;
    },

    closeReviewModal(force = false) {
      if (!force && this.loadingSetAgreement) return;
      this.showReviewModal = false;
    },

    async onModalConfirmAgreement() {
      try {
        if (this.brand === 'eudora') {
          await this.ActionNegotiationSetAgreementEudora();
        } else {
          await this.ActionNegotiationSetAgreementBoticario();
        }
        this.showReviewModal = false;
        this.$store.commit('negotiation/SET_VIEW', this.brand === 'eudora' ? 'finishEudora' : 'finishBoticario');
        this.flashMessage.show({ timeout: 1000, status: 'success', title: 'Sucesso', message: 'Acordo fechado com sucesso' });
      } catch (err) {
        this.flashMessage.show({
          timeout: 8000,
          status: 'error',
          title: 'Erro',
          message: err.message || 'Não foi possível confirmar na tela. Atualize a página antes de tentar de novo; o acordo pode já ter sido registrado.',
        });
      }
    },

    truncated(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
  },
};
</script>

<style scoped>
.payment-screen {
  padding-top: 8px;
  padding-bottom: 32px;
}

.payment-screen__title {
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #333438;
  margin: 12px 0 16px;
}

.payment-card {
  border: none;
  border-top: 4px solid #06a472;
  border-radius: 20px;
  padding: 16px 20px;
  background: #fff;
  box-shadow: var(--negotiation-card-shadow, 0 2px 12px rgba(0, 0, 0, 0.1));
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payment-card__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.payment-card__brand-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.payment-card__brand-name {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  color: #333438;
}

.payment-card__row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  color: #333438;
}
.payment-card__label {
  color: #666;
  font-weight: 400;
  white-space: nowrap;
}
.payment-card__value {
  font-weight: 600;
  color: #333438;
}

.payment-card__divider {
  margin: 6px 0;
  border-color: #e6e7e9;
}

.payment-card__titles-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
}
.payment-card__titles-value {
  flex: 1;
  font-weight: 400;
  color: #333438;
  word-break: break-word;
  line-height: 1.4;
}
.payment-card__btn-expand {
  background: transparent;
  border: none;
  color: #176e53;
  cursor: pointer;
  padding: 2px 4px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
}
.payment-card__btn-expand:focus { outline: none; }
.payment-card__btn-expand i { font-size: 0.85rem; }

.payment-screen__section-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #333438;
  margin-bottom: 12px;
}

.payment-screen__section-label--desktop-first {
  display: none;
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.payment-option-stack {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.payment-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s, background-color 0.2s;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #333438;
}
.payment-option:hover {
  border-color: #06a472;
}
.payment-option--selected {
  border-color: #06a472;
  background: #f0faf6;
}

.payment-option--selected-card {
  border-color: #b5b5b5;
  background: #e8e8e8;
}
.payment-option--selected-card:hover {
  border-color: #9a9a9a;
}

.payment-option-card-info {
  padding: 12px 4px 4px 4px;
  font-family: 'Inter', sans-serif;
}
.payment-option-card-info__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}
.payment-option-card-info__row:last-child {
  margin-bottom: 0;
}
.payment-option-card-info__gutter {
  width: 20px;
  min-width: 20px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 1px;
  box-sizing: border-box;
}
.payment-option-card-info__icon-wrap {
  display: flex;
  line-height: 0;
}
.payment-option-card-info__text {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: #666;
  font-style: italic;
  font-weight: 400;
}

.payment-option__start {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.payment-option__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.payment-option__pix-img {
  display: block;
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.payment-option__label {
  font-weight: 400;
}

.payment-option__check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 8px;
}
.payment-option__check-icon {
  display: block;
}

.btn-confirm-agreement {
  width: 100%;
  background-color: #06a472;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 16px;
}
.btn-confirm-agreement:hover:not(:disabled) {
  background-color: #05966a;
}
.btn-confirm-agreement:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-back-offer {
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  color: #06a472;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  text-align: center;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: underline;
}
.btn-back-offer:hover { color: #05966a; }

@media (min-width: 768px) {
  .payment-screen {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    width: 100%;
  }

  .payment-screen__detail-grid {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 32px;
    row-gap: 14px;
    align-items: start;
  }

  .payment-screen__title {
    grid-column: 1;
    grid-row: 1;
    margin: 0;
    align-self: end;
  }

  .payment-screen__section-label--desktop-first {
    display: block;
    grid-column: 2;
    grid-row: 1;
    margin: 0;
    align-self: end;
  }

  .payment-screen__section-label--mobile-only {
    display: none;
  }

  .payment-card {
    grid-column: 1;
    grid-row: 2;
    margin-bottom: 0;
  }

  .payment-options {
    grid-column: 2;
    grid-row: 2;
    margin-bottom: 24px;
    min-width: 0;
  }

  .payment-screen__footer-actions {
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    padding-top: 28px;
    padding-bottom: 24px;
  }
}

.payment-review-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  background: rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
}

.payment-review-dialog {
  width: 100%;
  max-width: 420px;
  max-height: min(90vh, 720px);
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--negotiation-card-shadow, 0 8px 32px rgba(0, 0, 0, 0.18));
  padding: 20px 20px 24px;
  font-family: 'Inter', sans-serif;
}

.payment-review-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.payment-review-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #333438;
  line-height: 1.3;
}

.payment-review-close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  margin: -6px -8px 0 0;
  border: none;
  background: transparent;
  color: #888;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.payment-review-close:hover {
  color: #333438;
  background: #f2f2f2;
}

.payment-review-subtitle {
  margin: 0 0 16px;
  font-size: 0.88rem;
  color: #666;
  font-weight: 400;
}

.payment-review-card {
  border: none;
  border-top: 4px solid #06a472;
  border-radius: 16px;
  padding: 14px 16px 16px;
  background: #fff;
  box-shadow: var(--negotiation-card-shadow, 0 2px 12px rgba(0, 0, 0, 0.08));
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payment-review-card__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.payment-review-card__brand-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.payment-review-card__brand-name {
  font-size: 0.95rem;
  color: #333438;
}

.payment-review-card__row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  font-size: 0.82rem;
  color: #333438;
}
.payment-review-card__label {
  color: #666;
  font-weight: 400;
  white-space: nowrap;
}
.payment-review-card__value {
  font-weight: 600;
  color: #333438;
}

.payment-review-btn-confirm {
  width: 100%;
  background-color: #06a472;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 12px;
}
.payment-review-btn-confirm:hover:not(:disabled) {
  background-color: #05966a;
}
.payment-review-btn-confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.payment-review-btn-cancel {
  display: block;
  width: 100%;
  background: none;
  border: none;
  color: #176e53;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  cursor: pointer;
  padding: 8px 0;
  text-align: center;
}
.payment-review-btn-cancel:hover {
  text-decoration: underline;
  color: #06a472;
}

.payment-screen--eudora .payment-card,
.payment-screen--eudora .payment-review-card {
  border-top-color: #613a53;
}
.payment-screen--eudora .payment-card__btn-expand {
  color: #613a53;
}
.payment-screen--eudora .payment-option:hover {
  border-color: #613a53;
}
.payment-screen--eudora .payment-option--selected {
  border-color: #613a53;
  background: rgba(97, 58, 83, 0.06);
}
.payment-screen--eudora .btn-confirm-agreement {
  background-color: #613a53;
}
.payment-screen--eudora .btn-confirm-agreement:hover:not(:disabled) {
  background-color: #4d2e42;
}
.payment-screen--eudora .btn-back-offer {
  color: #613a53;
}
.payment-screen--eudora .btn-back-offer:hover {
  color: #4d2e42;
}
.payment-screen--eudora .payment-review-btn-confirm {
  background-color: #613a53;
}
.payment-screen--eudora .payment-review-btn-confirm:hover:not(:disabled) {
  background-color: #4d2e42;
}
.payment-screen--eudora .payment-review-btn-cancel {
  color: #613a53;
}
.payment-screen--eudora .payment-review-btn-cancel:hover {
  color: #613a53;
}
</style>
